import type { LinkedLayer } from './linked-layer';

export interface TextFieldProperties {
    autoTextScaling: boolean;
    charLimit: number;
}

export enum FieldType {
    Text = 'text',
    Image = 'image',
}

export interface Field {
    id?: number;
    name: string;
    type: FieldType;
    templateVersion: number;
    linkedLayers?: LinkedLayer[];
    properties: TextFieldProperties;
}

export interface FieldValue {
    id?: number;
    contentVariant: number;
    field: number;
    value: string;
}
